import React, { useState, useEffect } from 'react';
import {useSelector} from 'react-redux'
import ChatHeader from '../ChatHeader/ChatHeader'
import MessageBox from '../MessageBox/MessageBox'
import MessageInput from '../MessageInput/MessageInput'
import './Messenger.scss'
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import connecting_teams from '../../../../assets/images/connecting_teams.svg'
import { useDispatch } from 'react-redux';
import ChatService from '../../../../services/chatService'

const Messenger = () => {

    const chat = useSelector(state => state.chatReducer.currentChat);
    const dispatch = useDispatch();
    const [messages, setMessages] = useState([]);
    const [chatMessages, setChatMessages] = useState({});
    const socket = useSelector(state => state.chatReducer.socket);
    const [pendingAction, setPendingAction] = useState(null);

    const activeChat = () => {
        return Object.keys(chat).length > 0
    };

    const isBotChat = chat && chat.name === 'IOP Bot';  // <-- Bot Chat Detection
    const sendBotMessage = async (message) => {
        try {
            const response = await fetch('http://localhost:3978/api/chat', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ message })
            });
            const data = await response.json();
            let botReply;
            const botUser = chat.Users.find(user => user.firstName.toLowerCase().includes('bot'));
            console.log("botUser:",botUser);
            if (data.type === "options") {
                // Dynamic options message
                botReply = {
                    type: "options",
                    chatId: chat.id,
                    message: data.message,
                    options: data.options,
                    fromUser: { id: botUser.id, firstName: botUser.firstName },
                    toUserId: chat.Users.map(user => user.id)
                };
            } else {
                // Normal text reply
                const replyText = data.reply || data.message || "Sorry, I didn’t understand that.";
                botReply = {
                    type: 'bot',
                    chatId: chat.id,
                    message: replyText,
                    fromUser: { id: botUser.id, firstName: botUser.firstName },
                    toUserId: chat.Users.map(user => user.id)
                };
            }

            if (data.type === 'action_fulfillment') {
                setPendingAction({
                    type: data.type,
                    action: data.action,
                    screenParams: data.screen_params
                });
            }

            // Send it to socket or dispatch to store
            // socket.emit('message', botReply);
            if (socket && typeof socket.emit === 'function') {
                socket.emit('message', botReply);
            } else {
                console.log('Socket not initialized yet.');
            }

        } catch (error) {
            console.error("Error communicating with bot:", error);
        }
    };

    const handleUserMessage = (message) => {
        const botUser = chat.Users.find(user =>
            user.firstName && user.firstName.toLowerCase().includes('bot')
        );

        if (pendingAction) {
            
            const payload = {
                type: pendingAction.type,
                action: pendingAction.action,
                params: pendingAction.screenParams, // can be an object directly
                message: message
            };
            
            let botReply;
            ChatService.raiseTicket(payload)
                .then(response => {
                    console.log("Response Front End=",response);
                    botReply = {
                        type: 'bot',
                        chatId: chat.id,
                        message: response.reply,
                        fromUser: {
                            id: botUser?.id || 0,
                            firstName: botUser?.firstName || 'IOP Bot'
                        },
                        toUserId: chat.Users.map(user => user.id)
                    };
                    socket.emit('message', botReply);

                })
                .catch(err => console.log("FRONTEND ERROR:".err));

            setPendingAction(null); // clear after fulfilling
        }
        else {
            if (chat && chat.type === 'bot') {
                sendBotMessage(message);
            }
        }

    };
    

    const handleOptionClick = (optionValue) => {
        if (!chat || !optionValue) return;

        const user = JSON.parse(localStorage.getItem('user'));

        const userMessage = {
            type: 'text',
            fromUser: { ...user },
            chatId: chat.id,
            message: optionValue,
            toUserId: chat.Users.map(user => user.id)
        };

        // Emit user message through socket
        socket.emit('message', userMessage);

        // If it's a bot chat, send to bot logic
        if (chat.type === 'bot') {
            sendBotMessage(optionValue);
        }
    };


    return (
        <div id='messenger' className='shadow-light'>
            {
                activeChat()
                    ? <div id='messenger-wrap'>
                        <ChatHeader chat={chat}/>
                        <hr/>
                        <MessageBox chat={chat} onOptionClick={handleOptionClick} />
                        <MessageInput chat={chat} onSendMessage={handleUserMessage} />
                    </div>
                    : <div id='noActiveChat-div'>
                        <img src={connecting_teams} className="d-inline-block align-top" alt="SparrowChat"/>
                        <p><FontAwesomeIcon icon='sad-tear' className='fa-icon'/> No active chat !!!</p>
                    </div>
            }
        </div>
    )
};

export default Messenger